import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import "./navbar.css";

const Navbar = () => {
  return (
    <div className="navbar_container">
      <div className="navbar_desktop container">
        <Link smooth className="navbar_link" to="/#home">
          Home
        </Link>

        <Link smooth className="navbar_link" to="/#about">
          About
        </Link>

        <Link smooth className="navbar_link" to="/#myWork">
          My Work
        </Link>

        <Link smooth className="navbar_link" to="/#contact">
          Contact
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
